const LIGHT = {
  '--na-scheme': 'light',
  '--na-primary': '#2f4b7c',
  '--na-primary-hover': '#253d66',
  '--na-primary-soft': '#8fa9d3',
  '--na-on-primary': '#ffffff',
  '--na-focus-border': '#2f4b7c',
  '--na-link': '#2f4b7c',
  '--na-link-hover': '#253d66',
  '--na-ink': '#0f172a',
  '--na-brand-ink': '#334155',
  '--na-muted': '#5b6475',
  '--na-placeholder': '#6b7385',
  '--na-border': '#8a93a3',
  '--na-input-bg': '#ffffff',
  '--na-card': '#ffffff',
  '--na-card-border': 'rgba(15, 23, 42, 0.06)',
  '--na-card-shadow': '0 24px 60px -28px rgba(15, 23, 42, 0.28), 0 2px 6px rgba(15, 23, 42, 0.04)',
  '--na-icon-bg': '#e8edf5',
  '--na-icon': '#2f4b7c',
  '--na-error': '#b42318',
  '--na-focus-ring': 'rgba(47, 75, 124, 0.18)',
  '--na-page-bg': 'radial-gradient(1100px 620px at 8% -12%, #e2e9f4 0%, rgba(226, 233, 244, 0) 62%), radial-gradient(900px 560px at 108% 112%, #e5ebf5 0%, rgba(229, 235, 245, 0) 58%), #f4f6fa',
  '--na-panel-bg': 'linear-gradient(160deg, #fbfcfe 0%, #eef2f8 55%, #e3eaf5 100%)',
  '--na-glass': 'linear-gradient(160deg, rgba(255, 255, 255, 0.75), rgba(226, 233, 244, 0.3))',
  '--na-glass-border': 'rgba(255, 255, 255, 0.9)',
  '--na-glass-shadow': '0 30px 80px -40px rgba(47, 75, 124, 0.35)',
  '--na-orb-1': 'rgba(143, 169, 211, 0.5)',
  '--na-orb-2': 'rgba(47, 75, 124, 0.12)',
  '--na-mark-back': '#8fa9d3',
  '--na-mark-front': '#2f4b7c',
}

const DARK = {
  '--na-scheme': 'dark',
  '--na-primary': '#3d62a3',
  '--na-primary-hover': '#4a72b8',
  '--na-primary-soft': '#6f8fc6',
  '--na-on-primary': '#ffffff',
  '--na-focus-border': '#9db8e6',
  '--na-link': '#9db8e6',
  '--na-link-hover': '#c1d3f1',
  '--na-ink': '#e7ecf4',
  '--na-brand-ink': '#c9d3e3',
  '--na-muted': '#a3aec0',
  '--na-placeholder': '#8b96a8',
  '--na-border': '#607089',
  '--na-input-bg': '#0f1726',
  '--na-card': '#131c2c',
  '--na-card-border': 'rgba(255, 255, 255, 0.06)',
  '--na-card-shadow': '0 24px 60px -28px rgba(0, 0, 0, 0.7), 0 2px 6px rgba(0, 0, 0, 0.3)',
  '--na-icon-bg': '#1b2638',
  '--na-icon': '#9db8e6',
  '--na-error': '#f19a8f',
  '--na-focus-ring': 'rgba(157, 184, 230, 0.25)',
  '--na-page-bg': 'radial-gradient(1100px 620px at 8% -12%, #16213a 0%, rgba(22, 33, 58, 0) 62%), radial-gradient(900px 560px at 108% 112%, #14203a 0%, rgba(20, 32, 58, 0) 58%), #0b111c',
  '--na-panel-bg': 'linear-gradient(160deg, #151f31 0%, #111a29 55%, #0f1828 100%)',
  '--na-glass': 'linear-gradient(160deg, rgba(255, 255, 255, 0.06), rgba(157, 184, 230, 0.04))',
  '--na-glass-border': 'rgba(255, 255, 255, 0.08)',
  '--na-glass-shadow': '0 30px 80px -40px rgba(0, 0, 0, 0.6)',
  '--na-orb-1': 'rgba(61, 98, 163, 0.35)',
  '--na-orb-2': 'rgba(157, 184, 230, 0.1)',
  '--na-mark-back': '#3d62a3',
  '--na-mark-front': '#9db8e6',
}

const markColorsOf = (tokens) => ({
  '--na-mark-back': tokens['--na-mark-back'],
  '--na-mark-front': tokens['--na-mark-front'],
})

export const NEUTRAL_MARK_COLORS = { light: markColorsOf(LIGHT), dark: markColorsOf(DARK) }

const declarations = (tokens) => Object.entries(tokens).map(([name, value]) => `  ${name}: ${value};`).join('\n')

const NEUTRAL_FONT_IMPORT = "@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');"

export const NEUTRAL_FONT_STACK = "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif"

export const NEUTRAL_THEME_CSS = `:root {
${declarations(LIGHT)}
}
:root[data-theme="dark"] {
${declarations(DARK)}
}`

export const NEUTRAL_STYLESHEET_HEAD = `${NEUTRAL_FONT_IMPORT}
${NEUTRAL_THEME_CSS}`
